<template>
  <div 
    class="mt-5">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.warning"
          width="350">
          <v-card 
            class="border-radius pa-2">
            <v-card-text>
              <v-img 
                width="125"
                height="125"
                alt="kominfoklaten" 
                :src="require('@/assets/icon/info_warning.png')"
                class="ma-auto my-6">
                <template v-slot:placeholder>
                  <v-row
                    class=" "
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <div
                class="body-1 text-center line-text-second">
                <div>
                  Harap mengisi
                  <span v-if="filter.start_date === ''">tanggal mulai periode</span><span v-if="filter.start_date === '' && filter.end_date === '' && (filter.coa === '' || filter.coa === null)">, </span><span v-if="filter.start_date === '' && filter.end_date === '' && filter.coa !== '' && filter.coa !== null"> dan </span>
                  <span v-if="filter.end_date === ''">tanggal akhir periode</span><span v-if="(filter.start_date === '' && (filter.coa === '' || filter.coa === null)) || (filter.end_date === '' && (filter.coa === '' || filter.coa === null))"> dan </span>
                  <span v-if="filter.coa === '' || filter.coa === null">Chart of Account</span>
                  terlebih dahulu
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.error"
          width="350">
          <v-card 
            class="border-radius pa-2">
            <v-card-text>
              <v-img 
                width="125"
                height="125"
                alt="kominfoklaten" 
                :src="require('@/assets/icon/info_warning.png')"
                class="ma-auto my-6">
                <template v-slot:placeholder>
                  <v-row
                    class=" "
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <div
                class="body-1 text-center line-text-second">
                <div>
                  {{ message.error }}
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div 
                        class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.freeze">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.freeze ? 'font-weight-bold' : ''"
                                :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.hide = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in headers" 
                            :key="index"
                            class="px-0"
                            @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.hide">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.hide ? 'font-weight-bold' : ''"
                                :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Filter Data
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.filter = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <div>
                
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn 
                @click="dialog.filter = false; fetch();"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Filter
              </v-btn>

              <v-btn 
                @click="dialog.filter = false"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                {{ form.id === '' ? 'Tambah' : 'Ubah' }}
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider
                    name="Nama Satuan" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Nama Satuan
                    </div>

                    <v-text-field
                      v-on:keydown.enter.prevent="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Contoh. pcs"

                      hide-details

                      v-model="form.name"
                      :success="form.name !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.name !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.detail"
          @keydown.esc="dialog.detail = false"
          :fullscreen="dialog.fullscreen"
          width="calc(100vw - 60px)"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Data Jurnal di Bukti Transaksi<b class="font-weight-bold black--text pl-2" v-if="selected.list.length > 0">{{ selected.list[0].number }}</b>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.detail = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-0 px-4">
              <div class="view">
                <v-row
                  class="py-0">
                  <v-col
                    cols="12"
                    md="12"
                    class="d-flex align-center">
                    <!-- <v-btn
                      color="#4B4B4B"
                      elevation="0"
                      :disabled="process.load"
                      @click="dialog.form = true; reset();"
                      class="body-2 white--text text-capitalize d-flex align-center ml-0"
                      style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                      <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                      
                      <span
                        class="ml-2">
                        Tambah
                      </span>
                    </v-btn> -->
                    <!-- <v-text-field
                      @click:clear="search_plafon = ''; fetchDetail(selected.list[0].id);"
                      v-on:keyup.enter="fetchDetail(selected.list[0].id)"
      
                      filled
                      rounded
                      dense
                      single-line
      
                      hide-details
                      :color="set_color"
                      placeholder="Cari data yang Anda butuhkan . . ."
                      append-icon="mdi-magnify"
                      clearable
      
                      v-model="search_plafon"
                      min-height="30"
                      class="ml-3 fs-12 little-placeholder"
                      style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 320px">
                    </v-text-field> -->
      
                    <!-- FREEZE COLUMN -->
                    <!-- <div class="ml-3">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            elevation="0"
                            outlined
                            dark
                            min-width="36"
                            color="#7B7B7B"
                            class="text-capitalize px-0"
                            style="border-radius: 10px;"
                            v-bind="attrs"
                            v-on="on"
                            @click="dialog.freeze = true">
                            <v-icon size="18">mdi-table-split-cell</v-icon>
                          </v-btn>
                        </template>
      
                        <span>
                          Freeze
                        </span>
                      </v-tooltip>
                    </div> -->
      
                    <!-- HIDE COLUMN -->
                    <!-- <div class="ml-3">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            elevation="0"
                            outlined
                            dark
                            min-width="36"
                            color="#7B7B7B"
                            class="text-capitalize px-0"
                            style="border-radius: 10px;"
                            v-bind="attrs"
                            v-on="on"
                            @click="dialog.hide = true">
                            <v-icon size="18">mdi-eye-off-outline</v-icon>
                          </v-btn>
                        </template>
      
                        <span>
                          Hide
                        </span>
                      </v-tooltip>
                    </div> -->
                  </v-col>
                </v-row>
                <div v-if="!process.detail" :class="process.detail || list_jurnal.length === 0 ? '' : 'wrapper-project'">
                  <table style="border: 1px solid #ededed; width: 100%;" class="table mb-1" v-for="(items, i) in list_jurnal" :key="i">
                    <tr>
                      <th class="sticky-col one-col" style="z-index: 1; background: #080679; color: white; font-size: 12px; border: 1px solid #ededed; border-left: none; width: 15opx; min-width: 15opx; max-width: 15opx; padding: 8px 12px; text-align: center;">Tanggal</th>
                      
                      <th style="font-size: 12px; z-index: 1; width: 150px; min-width: 150; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;" :style="`background-color: ${set_color}; color: #fff;`">No Transaksi</th>
                      <th style="font-size: 12px; z-index: 1; width: 100px; min-width: 100; max-width: 100px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;" :style="`background-color: ${set_color}; color: #fff;`">Ref</th>
                      <th style="font-size: 12px; z-index: 1; width: 150px; min-width: 150; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;" :style="`background-color: ${set_color}; color: #fff;`">Posisi</th>
                      <th style="font-size: 12px; z-index: 1; width: 150px; min-width: 150; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;" :style="`background-color: ${set_color}; color: #fff;`">Nama Project</th>
                      <th style="font-size: 12px; z-index: 1; width: 150px; min-width: 150; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;" :style="`background-color: ${set_color}; color: #fff;`">Catatan Project</th>
                      <th style="font-size: 12px; z-index: 1; width: 150px; min-width: 150; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;" :style="`background-color: ${set_color}; color: #fff;`">Nama Vendor</th>
                      <th style="font-size: 12px; z-index: 1; width: 120px; min-width: 120; max-width: 120px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;" :style="`background-color: ${set_color}; color: #fff;`">Nama Divisi</th>
                      <th style="font-size: 12px; z-index: 1; width: 150px; min-width: 150; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;" :style="`background-color: ${set_color}; color: #fff;`">No Akun</th>
                      <th style="font-size: 12px; z-index: 1; width: 150px; min-width: 150px; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;" :style="`background-color: ${set_color}; color: #fff;`">Nama Akun</th>
                      <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;" :style="`background-color: ${set_color}; color: #fff;`">Keterangan</th>
                      <th style="font-size: 12px; z-index: 1; width: 150px; min-width: 150; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;" :style="`background-color: ${set_color}; color: #fff;`">Debit</th>
                      <th style="font-size: 12px; z-index: 1; width: 150px; min-width: 150; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;" :style="`background-color: ${set_color}; color: #fff;`">Kredit</th>
                      <!-- <th style="font-size: 12px; z-index: 1; width: 120px; min-width: 120; max-width: 120px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;" :style="`background-color: ${set_color}; color: #fff;`">Admin</th> -->
                      <!-- <th style="font-size: 14px !important; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;">Realisasi</th>
                      <th style="font-size: 14px !important; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">Selisih</th> -->
                    </tr>
                    <tr v-for="(item, index) in items.detail_array" :key="index" @click="selected.row = (((`100${index}`) + index) * (i+1))" :class="selected.row === (((`100${index}`) + index) * (i+1)) ? 'selected' : ''">
                      <td style="font-size: 12px; border: 1px solid #ededed; width: 150px; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: center;">{{ item.datetime | date }}</td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; width: 150px; min-width: 150; max-width: 150px; text-align: center;">{{ items.number }}</td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; width: 100px; min-width: 100; max-width: 100px; text-align: center;">{{ item.ref }}</td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; width: 150px; min-width: 150; max-width: 150px; text-align: center;" class="text-capitalize">
                        <v-chip
                          :color="item.position === 'public' ? 'green' : 'orange'"
                          small
                          class="white--text">
                          {{ item.position }}
                        </v-chip>
                      </td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; width: 150px; min-width: 150; max-width: 150px; text-align: center;">{{ item.project_name === '' ? '-' : item.project_name }}</td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; width: 150px; min-width: 150; max-width: 150px; text-align: left;">{{ item.project_note === '' ? '-' : item.project_note }}</td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; width: 150px; min-width: 150; max-width: 150px; text-align: center;">{{ item.vendor_name === '' ? '-' : item.vendor_name }}</td>
                      <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 120px; min-width: 120; max-width: 120px; padding: 8px 12px; text-align: center;">
                        <!-- {{ item.input_admin_name }} -->
                        <div v-if="item.unit_array.length > 0">
                          <div v-for="(units, index) in item.unit_array" :key="index">
                            {{ units.name }} 
                            <!-- (
                              <span v-for="(cat, i) in units.category_array" :key="i">
                                {{ cat.title}} <span v-if="i < units.category_array.length - 1">, </span>
                              </span>
                            ) -->
                            <span v-if="index < item.unit_array.length - 1">, </span>
                          </div>  
                        </div>
                        <div v-else>
                          -
                        </div>
                      </td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; width: 150px; min-width: 150; max-width: 150px; text-align: center;">{{ item.coa_number }}</td>
                      <td style="font-size: 12px; border: 1px solid #ededed; width: 150px; min-width: 150px; max-width: 150px; border-left: none; padding: 8px 12px; text-align: left;">
                        {{ item.coa_name }}
                      </td>
                      <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 150px; min-width: 150; max-width: 150px;">
                        {{ item.note }}
                      </td>
                      <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 200px; min-width: 150; max-width: 200px; padding: 8px 12px; text-align: right;">
                        {{ item.debit | price }}
                      </td>
                      <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 200px; min-width: 150; max-width: 200px; padding: 8px 12px; text-align: right;">
                        {{ item.kredit | price }}
                      </td>
                      <!-- <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 120px; min-width: 120; max-width: 120px; padding: 8px 12px; text-align: right;">
                        {{ item.input_admin_name }}
                      </td> -->
                    </tr>
                    <tr @click="selected.row = 3" :class="selected.row === 3 ? 'selected' : ''">
                      <td colspan="11" style="font-size: 12px; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;" class="font-weight-bold">Total</td>
                      <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;" class="font-weight-bold">{{ items.total_debit | price }}</td>
                      <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;" class="font-weight-bold">{{ items.total_kredit | price }}</td>
                      <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;"></td>
                    </tr>
                  </table>
                </div>
  
                <v-card-text
                  v-if="process.detail" 
                  class="pb-0 my-4" 
                  style="height: 600px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-4 title">
                      Mohon Tunggu . . .
                    </div>
  
                    <v-progress-linear
                      :color="set_color"
                      indeterminate
                      rounded
                      height="10">
                    </v-progress-linear>
                  </div>
                </v-card-text>
  
                <v-card-text
                  v-if="!process.detail && list_jurnal.length === 0"
                  class="pb-0 my-4" style="height: 600px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <v-img 
                      class="mx-auto"
                      contain
                      alt="vuetify"
                      :width="90"
                      :height="90"
                      :src="require('@/assets/image/empty.png')">
                      <!-- <template v-slot:placeholder>
                        <v-row
                          class=" "
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template> -->
                    </v-img>
                    <div class="mt-3 fs-16">
                      Belum Ada Data
                    </div>
                  </div>
                </v-card-text>
              </div>
            </v-card-text>

            <!-- <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div> -->

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="dialog.detail = false; dialog.fullscreen = false;"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- <v-dialog v-model="dialog.detail"
          @keydown.esc="dialog.detail = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Detail Perusahaan

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.detail = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0" v-if="Object">
              <v-form>
                <v-row>
                  <v-col cols="6">
                    
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.detail = false; dialog.fullscreen = false; ">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
        
        <section>
          <!-- <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Pegawai
                    </span>
                  </div>

                  <v-spacer />

                  <div>
                    <v-btn
                      to="/user/add"
                      color="#4B4B4B"
                      elevation="0"
                      class="body-2 white--text text-capitalize d-flex align-center"
                      style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                      <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                      
                      <span
                        class="ml-2">
                        Tambah
                      </span>
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row> -->

          <v-card
            flat
            class="mt-0"
            color="transparent">
            <div
              class="d-flex align-center px-3">
              <div
                class="d-flex align-center">
                <v-avatar
                  tile
                  size="22">
                  <v-img
                    contain
                    alt="kominfoklaten"  
                    :src="require('@/assets/image/grip_menu.png')">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>

                <span
                  class="fs-16 black--text ml-2"
                  style="font-weight: 600;">
                  Buku Besar
                </span>
              </div>

              <v-spacer />
            </div>
          </v-card>
          <v-card-text class="pb-2">
            <div class="d-flex align-center mt-0">
              <div class="fs-13">
                Pilih Periode <span class="ml-1">:</span>
              </div>
              <v-text-field
                v-model="filter.start_date"
                @input="filter.end_date = ''"
                :color="set_color"
                placeholder="Pilihan tanggal"
                hide-details
                type="date"
                filled
                rounded
                dense
                class="fs-12 little-placeholder"
                style="border-radius: 6px; max-width: 150px;"
              ></v-text-field>
              <div class="fs-13 ml-1">
                s/d <span class="ml-1">:</span>
              </div>
              <v-text-field
                v-model="filter.end_date"
                :color="set_color"
                placeholder="Pilihan tanggal"
                hide-details
                @input="filter.coa !== '' && filter.coa !== null ? toFilter() : ''"
                :min="filter.start_date"
                type="date"
                filled
                rounded
                dense
                class="fs-12 little-placeholder"
                style="border-radius: 6px; max-width: 150px;"
              ></v-text-field>
              <div class="ml-2">
                <v-select
                  
                  filled
                  rounded
                  dense

                  :color="set_color"
                  placeholder="Pilih salah satu"
                  @input="filter.coa !== '' && filter.coa !== null ? toFilter() : ''"

                  hide-details
                  class="fs-11 little-placeholder"
                  :items="position"

                  v-model="filter.position"
                  style="border-radius: 6px; width: 150px; min-width: 150px; max-width: 150px;">
                </v-select>
              </div>
              <div class="ml-2">
                <v-autocomplete
                  v-model="filter.coa"
                  :items="coa"
                  item-text="name"
                  item-value="id"
                  @input="toFilter()"
                  :color="set_color"
                  placeholder="Pilih CoA"
                  hide-details
                  filled
                  rounded
                  dense
                  class="fs-11 little-placeholder"
                  style="border-radius: 6px;">
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title class="fs-11">{{ item.name }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </div>
              <div class="ml-3" v-if="hak_akses.action.export">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="exports()"
                      :loading="process.export"
                      elevation="0"
                      dark
                      min-height="28"
                      small
                      :disabled="filter.coa === '' || filter.coa === null"
                      min-width="28"
                      color="#097640"
                      class="text-capitalize px-0 white--text"
                      style="border-radius: 6px;"
                      v-bind="attrs"
                      v-on="on">
                      <v-icon size="18">mdi-microsoft-excel</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Export Excel
                  </span>
                </v-tooltip>
              </div>
              <!-- <div>
                <v-btn
                  @click="toFilter()"
                  :loading="process.load"
                  :disabled="process.load"
                  color="green"
                  rounded
                  small
                  height="30"
                  min-height="30"
                  elevation="0"
                  class="fs-12 font-weight-bold text-capitalize white--text ml-2"
                  style="border-radius: 6px;">
                  <v-icon small class="mr-1">mdi-filter</v-icon>
                  Filter
                </v-btn>
              </div> -->
            </div>
          </v-card-text>
          <v-divider class="mb-2 mt-0"></v-divider>
          <div class="d-flex px-3">
            <v-card flat style="border-radius: 10px; background-color: #455A64;">
              <v-card-text class="py-2">
                <div class="white--text pb-0">
                  <div class="d-flex">
                    <div class="fs-13 font_weight_600">
                      Awal Periode
                    </div>
                    <div class="fs-13 font-weight-bold ml-2">
                      : {{ awal_periode | price }}
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>

            <v-card flat style="border-radius: 10px; background-color: #4CAF50;" class="ml-3">
              <v-card-text class="py-2">
                <div class="white--text pb-0">
                  <div class="d-flex">
                    <div class="fs-13 font_weight_600">
                      Debit
                    </div>
                    <div class="fs-13 font-weight-bold ml-2">
                      : {{ total_debit | price }}
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>

            <v-card flat style="border-radius: 10px; background-color: #D81B60;" class="ml-3">
              <v-card-text class="py-2">
                <div class="white--text pb-0">
                  <div class="d-flex">
                    <div class="fs-13 font_weight_600">
                      Kredit
                    </div>
                    <div class="fs-13 font-weight-bold ml-2">
                      : {{ total_kredit | price }}
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>

            <v-card flat style="border-radius: 10px; background-color: #9E9E9E;" class="ml-3">
              <v-card-text class="py-2">
                <div class="white--text pb-0">
                  <div class="d-flex">
                    <div class="fs-13 font_weight_600">
                      Akhir Periode
                    </div>
                    <div class="fs-13 font-weight-bold ml-2">
                      : {{ akhir_periode | price }}
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </div>
          <v-row
            class="pa-4 mt-0 pt-2">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text
                  v-if="process.load" 
                  class="pb-0 my-4" 
                  style="height: calc(100vh - 276px); display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-4 title">
                      Mohon Tunggu . . .
                    </div>

                    <v-progress-linear
                      :color="set_color"
                      indeterminate
                      rounded
                      height="10">
                    </v-progress-linear>
                  </div>
                </v-card-text>

                <div class="view" v-if="!process.load">
                  <div :class="list.length < 1 ? '' : 'wrapper-buku-besar'">
                    <table style="border: 1px solid #ededed; width: 100%;" class="table">
                      <tr>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: center;" :style="`background-color: ${set_color};`">Aksi</th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: center;" :style="`background-color: ${set_color};`">Waktu Transaksi</th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: center;" :style="`background-color: ${set_color};`">No Bukti</th>
                        <!-- <th style="font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: center;" :style="`background-color: ${set_color};`">No Rekening</th> -->
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: left;" :style="`background-color: ${set_color};`">Keterangan</th>
                        <!-- <th style="font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: left;" :style="`background-color: ${set_color};`">Keterangan</th> -->
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: right;" :style="`background-color: ${set_color};`">Debit</th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: right;" :style="`background-color: ${set_color};`">Kredit</th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: right;" :style="`background-color: ${set_color};`">Saldo Akumulatif</th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: center;" :style="`background-color: ${set_color};`">Diinput Oleh</th>
                      </tr>
                      <tr v-for="(item, index) in list" :key="index" @click="selected.row = (((`100${index}`) + index) * (i+1))" :class="selected.row === (((`100${index}`) + index) * (i+1)) ? 'selected' : ''">
                        <td style="font-size: 12px; border: 1px solid #ededed; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: center;">
                          <v-tooltip 
                            top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="toDetail(item); selected.list = [item];"
                                
                                v-bind="attrs"
                                v-on="on"

                                min-width="28"
                                small
                                rounded
                                color="green"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon small>mdi-information-slab-circle-outline</v-icon>
                              </v-btn>
                            </template>

                            <span>Jurnal</span>
                          </v-tooltip>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; width: 150px; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: center;">{{ item.datetime | datetime }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: center;">{{ item.number }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: left;">{{ item.note }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: right;">{{ item.debit | price }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: right;">{{ item.kredit | price }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; width: 200px; padding: 8px 12px; text-align: right;">{{ item.saldo_akumulatif | price }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: center;">{{ item.input_admin_name }}</td>
                      </tr>
                      <!-- <tr>
                        <th colspan="4" style="font-size: 12px; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">Total</th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">Rp. 510.000.000</th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">Rp. 85.000.000</th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;"></th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;"></th>
                      </tr> -->
                    </table>
                  </div>
                  <v-card-text
                    v-if="list.length === 0"
                    class="pb-0 my-4" style="height: calc( 100vh - 295px ); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <v-img 
                        class="mx-auto"
                        contain
                        alt="vuetify"
                        :width="90"
                        :height="90"
                        :src="require('@/assets/image/empty.png')">
                        <!-- <template v-slot:placeholder>
                          <v-row
                            class=" "
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template> -->
                      </v-img>
                      <div class="mt-3 fs-16">
                        Belum ada data di periode dan akun yang dipilih
                      </div>
                    </div>
                  </v-card-text>
                </div>
                <pagination v-if="!process.load && pagination.total_data > 0"
                  @changePage="fetch($event)" 
                  @reloadPage="fetch($event)" 
                  :model="pagination" :display="paginationList"/>

              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,
        menu2: false,
        filter: {
          start_date: new Date(new Date().getFullYear(), new Date().getMonth(), 2).toISOString().substr(0, 10),
          end_date: new Date().toISOString().substr(0, 10),
          coa: '',
          transaction: '',
          position: 'Internal'
        },
        position: ['Internal', 'Public'],

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          delete: false,
          reset: false,

          filter: false,
          form: false,
          warning: false,
          error: false,
          detail: false
        },
        
        search: '',
        awal_periode: 0,
        total_debit: 0,
        total_kredit: 0,
        akhir_periode: 0,

        // filter: {
          
        // },

        selected: {
          row: '',
          freeze: [],
          delete: [],
          reset: [],
          list: []
        },

        list_jurnal: [],
        coa: [],

        options: {},
        headers: [],
        list: [],
        pagination: {},
        paginationList: {},

        lastIndex: 0,
        limit: 20,

        form: {
          id: '',
          name: ''
        },

        process: {
          load: false,

          delete: false,
          reset: false,
          form: false,
          detail: false,
          export: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue'),
    },
    watch: {
      // 'options': {
      //   handler () {
      //     let pagination = { row: this.limit, page: 1 }
          
      //     this.fetch(pagination)
      //   },
      //   deep: true
      // }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      hak_akses () {
        let menu = {}
        // console.log(this.$store.state.menu)
        this.$store.state.menu.map(item => {
          if (item.id === 5) {
            menu = item
          }
        })
        return menu
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      }
    },
    created () {
      if (String(this.$store.state.user.cat_id) === '21' || String(this.$store.state.user.cat_id) === '23') {
        this.position = ['Public']
        this.filter.position = 'Public'
      }
    },
    mounted () {
      this.fetchCoa()
      // this.fetch()
    },
    methods: {
      async fetchCoa () {
        let params = {
          limit: 100000000000
        }

        await get(`ledger/coa/options`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.coa = res.results.data
          }
        })
      },
      toFilter(){
        if(this.filter.start_date === '' || this.filter.end_date === '' || this.filter.coa === '' || this.filter.coa === null){
          this.dialog.warning = true
        } else {
          this.fetch()
        }
      },
      toDetail (item) {
        this.dialog.detail = true

        this.fetchDetail(item)
      },
      async fetchDetail (id) {
        this.process.detail = true
        this.list_jurnal = []

        let params = {
          number: id.number,
          'datetime[gte]': this.filter.start_date,
          'datetime[lte]': this.filter.end_date,
        }

        await get(`jurnal/data`, { params })
        .then(response => {
          let res = response.data

          this.process.detail = false

          if (res.status === 200) {
            this.list_jurnal = res.results.data
          }
        })
      },
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },
      async fetchSummary () {
        let params = {
          coa_id: this.filter.coa,
          start_date: this.filter.start_date,
          end_date: this.filter.end_date,
          position: (this.filter.position).toLowerCase()
        }

        await get(`ledger/summary`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            // this.coa = res.results.data
            this.total_debit = res.results.data.debit
            this.total_kredit = res.results.data.kredit
            this.awal_periode = res.results.data.saldo_awal
            this.akhir_periode = res.results.data.saldo_akhir
            this.process.load = false
          }
        })
      },

      async fetch (pagination = { row: 20, page: 1 }) {
        
        this.paginationList = pagination
        
        this.process.load = true

        this.limit = pagination.row
        let params = {
          limit: pagination.row,
          page: pagination.page,
          number: this.filter.transaction,
          coa_id: this.filter.coa,
          start_date: this.filter.start_date,
          end_date: this.filter.end_date,
          position: (this.filter.position).toLowerCase()
        }
        let url = 'ledger/data'

        await get(`${url}`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.list = res.results.data
            this.pagination = res.results.pagination !== undefined ? res.results.pagination : {}
            this.fetchSummary()
          } else {
            this.list = []
            this.pagination = {}
            this.process.load = false
            this.message.error = res.message
            this.dialog.error = true
          }
        })
      },

      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: index !== undefined ? this.list[index].id : '',
          name: index !== undefined ? this.list[index].name : '',
          // par_id: index !== undefined ? this.list[index].par_id : '0',
          // type: index !== undefined ? this.list[index].type : "",
          // is_active: index !== undefined ? this.list[index].is_active === 'Aktif'? 1 : 0 : 1
        }

        this.process.form = false

        this.message.error = ''
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.form.id === '' ? 'pos/satuan/add' : 'pos/satuan/update'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              if (this.form.id === '') {
                this.fetch()
              } else {
                this.fetch(this.paginationList)
              }
              this.reset()

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`pos/satuan/delete`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch(this.paginationList)
          } else {
            this.message.error = res.message
          }
        })
      },
      async exports () {
        this.message.error = ''

        this.process.export = true

        let params = {
          coa_id: this.filter.coa,
          coa_name: this.coa.find(coa => coa.id === this.filter.coa).name,
          start_date: this.filter.start_date,
          end_date: this.filter.end_date,
          position: (this.filter.position).toLowerCase()
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}/ledger/export_excel`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.export = false
          console.log(res.headers)
          let disposition = res.headers['content-disposition']
          console.log(disposition)
          var fileName = res.headers['content-disposition'].split('filename=')[1]
          // let filename = ''

          // if (disposition && disposition.indexOf('inline') !== -1) {
          //   var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          //   var matches = filenameRegex.exec(disposition);
          //   if (matches != null && matches[1]) { 
          //     filename = matches[1].replace(/['"]/g, '');
          //   }
          // }
          console.log(fileName)

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport Excel'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', fileName)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      }

    }
  }
</script>


<style>
table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
  border-collapse: collapse;
}

.view {
  margin: auto;
  width: 100%;
}

wrapper-project { 
  overflow-y: auto; 
  height: calc(100vh - 400px); 
} 

.wrapper-project-none { 
  /* overflow-y: auto; 
  height: calc(100vh - 270px);  */
} 

.wrapper-project th { 
  position: sticky; 
  top: 0; 
  /* background-color: #080679 !important; */
} 

.wrapper-buku-besar { 
  overflow-y: auto; 
  height: calc(100vh - 305px); 
} 
.wrapper-buku-besar th { 
  position: sticky; 
  top: 0; 
  background-color: #080679 !important;
} 
tr:hover {background-color: #1976d236;}
tr.selected {background-color: #1976d236;}
</style>